import { render, staticRenderFns } from "./BuyProduce.vue?vue&type=template&id=3d132ef5&scoped=true&"
import script from "./BuyProduce.vue?vue&type=script&lang=js&"
export * from "./BuyProduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d132ef5",
  null
  
)

export default component.exports